import { ICategory } from '@/_types';

type TProps = {
  category: ICategory | undefined;
  language: string;
};

export const getCategoryName = ({ category, language }: TProps): string => {
  return category?.translations[language]?.name || '';
};
